@if (data) {
  <div class="py-3">
    <div class="px-2">
      <h1 class="mb-0">Cryptocurrency Transaction Details</h1>
      <h2 class="mb-2">{{ data.amount }} {{ data.currency }}</h2>
    </div>
    <!-- Scrollable content wrapper -->
    <div style="max-height: 60vh; overflow-y: auto" class="px-3">
      <table class="table table-striped" style="table-layout: fixed">
        <tbody>
          <tr>
            <td>Reference Number</td>
            <td>
              <strong>{{ data.referenceNumber }}</strong>
            </td>
          </tr>
          <tr>
            <td>Webhook URL</td>
            <td style="word-break: break-all">
              <strong>{{ data.webhookUrl }}</strong>
            </td>
          </tr>
          <tr>
            <td>Payment ID</td>
            <td>
              <strong>{{ data.paymentId }}</strong>
            </td>
          </tr>
          <tr>
            <td>Create Date</td>
            <td>
              <strong>{{ data.createDate | date: 'yyyy-MM-dd HH:mm' }}</strong>
            </td>
          </tr>
          <tr>
            <td>Confirmed Time</td>
            <td>
              <strong>{{
                data.confirmedTime | date: 'yyyy-MM-dd HH:mm'
              }}</strong>
            </td>
          </tr>
          <tr>
            <td>Status</td>
            <td>
              <strong>{{ data.status }}</strong>
            </td>
          </tr>
          <tr>
            <td>Invoice Currency</td>
            <td>
              <strong>{{ data.invoiceCurrency }}</strong>
            </td>
          </tr>
          <tr>
            <td>Invoice Amount</td>
            <td>
              <strong>{{ data.invoiceAmount }}</strong>
            </td>
          </tr>
          <tr>
            <td>Confirmed</td>
            <td>
              <strong>{{ data.confirmed }}</strong>
            </td>
          </tr>
          <tr>
            <td>Confirmations</td>
            <td>
              <strong>{{ data.confirmations }}</strong>
            </td>
          </tr>
          <tr>
            <td>State</td>
            <td>
              <strong>{{ data.state }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="px-3 d-flex align-items-center justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" mat-dialog-close>
        Close
      </button>
    </div>
  </div>
}
